import { Button } from '@coop/components';
import type React from 'react';

import type { ApiProduct } from '../../../../models/ecommerce/product/ApiProduct';
import {
    EcomProductCard,
    EcomProductCardSkeleton,
} from '../../../ecommerce/components/EcomProductCard';
import useReactRouting from '../../../ecommerce/hooks/useReactRouting';
import type { PriceType } from '../../models/priceData/priceData';
import { useIsFromXXSmall } from '../atoms/ResponsiveBreakpoints';
import styles from './ProductSubstitutes.module.scss';

export interface ProductSubstitutesListProps {
    substitutes: ApiProduct[];
    onProductSubstitution: (product: ApiProduct) => void;
    priceType: PriceType;
}

export const ProductSubstitutesSkeletonList = () => {
    const isFromXXSmall = useIsFromXXSmall();

    return (
        <ul className={styles.List} aria-label="Laddar produktalternativ">
            {Array.from({ length: 3 }, (_, index) => (
                <li key={index}>
                    <EcomProductCardSkeleton
                        orientation={isFromXXSmall ? 'horizontal' : 'vertical'}
                    />
                </li>
            ))}
        </ul>
    );
};

const ProductTeaser = (
    props: Omit<React.ComponentProps<typeof EcomProductCard>, 'isALink' | 'handleLinkClick'>,
) => {
    const { push } = useReactRouting();

    return (
        <EcomProductCard
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
            isALink
            handleLinkClick={(e) => {
                e.preventDefault();
                push(props.product.url, true);
            }}
        />
    );
};

const ProductSubstitutesList = (props: ProductSubstitutesListProps) => {
    const isFromXXSmall = useIsFromXXSmall();

    const onButtonClick = (item: ApiProduct) => (e: React.MouseEvent) => {
        e.stopPropagation();
        props.onProductSubstitution(item);
    };

    if (!props.substitutes?.length) {
        return null;
    }

    return (
        <ul className={styles.List} aria-label="alternativa produkter">
            {props.substitutes.map((item: ApiProduct) => (
                <li key={item.identifier}>
                    <ProductTeaser
                        orientation={isFromXXSmall ? 'horizontal' : 'vertical'}
                        product={item}
                        currentVariant={undefined}
                        priceType={props.priceType}
                        sustainabilityDisplayOption="checkData"
                        actionsSlot={
                            <Button
                                aria-label={`Välj ${item.name}`}
                                theme="primary"
                                onClick={onButtonClick(item)}
                                fullWidth
                            >
                                Välj
                            </Button>
                        }
                    />
                </li>
            ))}
        </ul>
    );
};

export default ProductSubstitutesList;
